import { KEYS } from '../../../../l18n/constants';
import computeClassName from '../../../../utils/computeClassName';
import handleClick from '../../../../utils/handleClick';
import { useL18nContext } from '../../ContextProvider/L18n';
import UtilityLinks from '../UtilityLinks';
import CCIconProfile20x20 from '../../../libs/CiscoCore/Icon/Profile/20x20';
import UserName from './UserName';
import LogInLabel from './LogInLabel';
import UserMenu from '../UserMenu';
import CCIconGlobe20x20 from '../../../libs/CiscoCore/Icon/Globe/20x20';
import LanguageLabel from './LanguageLabel';
import LanguageMenu from "../LanguageMenu";

const constants = Object.freeze({
  CLASSNAME_BASE: 'relative hidden sm:flex sm:items-center sm:justify-end bg-cc-secondary text-cc-primary-contrast font-normal text-cc-body-small'
});

const propsDefaults = Object.freeze({
  isUserLoggedIn: false,
  userId: '',
  userName: '',
  isUserMenuOpened: false,
  toggleUserMenuFn: null,
  toggleOffUserMenuFn: null,
  isLanguageMenuOpened: false,
  toggleLanguageMenuFn: null,
  toggleOffLanguageMenuFn: null
});

export default function UtilityBar(
  {
    isLoggedInUser = propsDefaults.isUserLoggedIn,
    userId = propsDefaults.userId,
    userName = propsDefaults.userName,
    isUserMenuOpened = propsDefaults.isUserMenuOpened,
    toggleUserMenuFn = propsDefaults.toggleUserMenuFn,
    toggleOffUserMenuFn = propsDefaults.toggleOffUserMenuFn,
    isLanguageMenuOpened = propsDefaults.isLanguageMenuOpened,
    toggleLanguageMenuFn = propsDefaults.toggleLanguageMenuFn,
    toggleOffLanguageMenuFn = propsDefaults.toggleOffLanguageMenuFn,
    className = ''
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedChooseLanguageSelectionText = getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION);

  const buttonUserMenuToggleClickFn = handleClick(toggleUserMenuFn);
  const buttonLanguageMenuToggleClickFn = handleClick(toggleLanguageMenuFn);

  return (
    <div className={computedClassName}>
      <UtilityLinks className=""/>
      <div className="relative">
        {
          isLoggedInUser ?
            <button className="appearance-none inline-flex item-center p-2 px-4 no-underline hover:underline hover:underline-thin hover:underline-lower" onClick={buttonUserMenuToggleClickFn}><CCIconProfile20x20 aria-hidden="true" className="w-3.5 h-3.5"/><UserName className="ml-1.25" userName={userName}/></button> :
            <button className="appearance-none inline-flex item-center p-2 px-4 no-underline hover:underline hover:underline-thin hover:underline-lower" onClick={buttonUserMenuToggleClickFn}><CCIconProfile20x20 aria-hidden="true" className="w-3.5 h-3.5"/><LogInLabel className="ml-1.25"/></button>
        }
        {
          isUserMenuOpened &&
          <UserMenu className="absolute z-10 top-full right-0"
                    isUserLoggedIn={isLoggedInUser}
                    userId={userId}
                    toggleOffUserMenuFn={toggleOffUserMenuFn}/>
        }
      </div>
      <div className="relative">
        <button className="appearance-none inline-flex item-center p-2 px-4 no-underline hover:underline hover:underline-thin hover:underline-lower mr-20" title={translatedChooseLanguageSelectionText} onClick={buttonLanguageMenuToggleClickFn}><CCIconGlobe20x20 aria-hidden="true" className="w-3.5 h-3.5"/><LanguageLabel className="ml-1.25"/></button>
        {
          isLanguageMenuOpened &&
          <LanguageMenu className="absolute z-10 top-full right-0"
                        toggleOffLanguageMenuFn={toggleOffLanguageMenuFn}/>
        }
      </div>
    </div>
  );
}


